import React, { useState, useEffect } from 'react'
import { Link  } from "react-router-dom"
import './common.css'
import API_URL from '../common/Apiurl';
import SuccessMessage from '../common/Message';

function Addfeedback(){
    const apiUrl = API_URL;
    const [items, setItems] = useState([]);
    const [successMessages, setSuccessMessages] = useState([]);
    const [feedback, setFeedback] = useState("");
    const [adminaction, setAdminaction] = useState("");
    const [industryId, setindustryId] = useState("");

    useEffect(() => {
      const getComments = async () => {
        try{
          const res = await fetch(`${apiUrl}/industrylist`,{
              method:'GET',
              headers:{
                  "Content-Type":"application/json",
                  "Accept":"application/json"
              },
          });
          const data = await res.json();
          if(data.status !== 200){
            throw new Error('Data not found');
          }
          setItems(data.data);
        }catch(error){
          console.error('Error ', error)
        }
      };
      getComments();
    }, []);

    const clicktoaddfeedback = async (e) => {
        e.preventDefault();
        const postData = {
            feedback_name: feedback,
            admin_action: adminaction,
            industry_type: industryId
        };
        console.log(postData);
        const result = await fetch(`${apiUrl}/admin/addfeedback`,{
            method:'POST',
            headers:{
                "Content-Type":"application/json",
                "Accept":"application/json"
            },
            body:JSON.stringify(postData)
        });
        const data = await result.json();
        if((data.status === 200)){
            const newSuccessMessage = data.message;
            setSuccessMessages([...successMessages, newSuccessMessage]);
        }else if((data.status === 400)){
            const newSuccessMessage = data.message;
            setSuccessMessages([...successMessages, newSuccessMessage]);
        }
        setFeedback(' ');
    }
    const handleSuccessMessageFadeOut = () =>{
        setSuccessMessages((prevMessages) => prevMessages.slice(1));
        window.location.reload();
    }
    return (
        <div className='width90'>
            <h2 className='pageTitle'>Add Feedback</h2>
            <div className='commonCntr'>
                <form className="form-horizontal"  onSubmit={clicktoaddfeedback}>
                    <div className="form-group">
                        <label className="control-label col-sm-2 label" htmlFor="feedback">Feedback Title:</label>
                        <div className="col-sm-4">
                            <input type="text" onChange={(e)=>setFeedback(e.target.value)} className="form-control" id="feedback" placeholder="Enter Feedback" value={feedback}/>
                        </div>
                    </div>
                    <div className="form-group mt-5">
                        <label className="control-label col-sm-2 label" htmlFor="permissiontype">Admin action:</label>
                        <select className="form-select col-sm-5 selectBox" onChange={(e)=>setAdminaction(e.target.value)}>
                            <option value=''>Select Action Type</option>
                            <option value="yes">Yes</option>
                            <option value="no">No</option>
                        </select>
                    </div>
                    <div className="form-group mt-5">
                        <label className="control-label col-sm-2 label" htmlFor="industrytype">Industry Type:</label>
                        <select className="form-select col-sm-5 selectBox" onChange={(e)=>setindustryId(e.target.value)}>
                            <option value=''>Select Industry Name</option>
                            {items.map((item , index) => {
                                return(<option value={item.id}>{item.industry_name}</option>
                            )})}
                        </select>
                    </div>
                    <div className="form-group">
                        <div className="col-sm-offset-2 col-sm-10">
                            <button type="submit" className="btn btn-default submitBtn">Submit</button>
                        </div>
                    </div>
                    {
                        successMessages.map((message, index) => (
                            <SuccessMessage
                                key={index} 
                                message = {message} 
                                onFadeOut={handleSuccessMessageFadeOut}
                            />
                        )
                    )}
                </form>
            </div>
        </div>
    )
}

export default Addfeedback;